var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"popup popup--push"},[_c('v-card-title',{staticClass:"popup__title"},[_vm._v(" Просмотр рассылки в мессенджеры ")]),_c('v-card-text',{staticClass:"popup__content"},[_c('app-club-push-messengers-popup',{attrs:{"item":_vm.data}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }